import './contacts.scss';

import { useContext, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Input, MaskedInput, Select } from '@/components/Shared/ui';
import { DictTypes } from '@/constants';
import { setDictionaryOptions } from '@/services';
import { useAppSelector } from '@/store';

import { CreateTabContext } from '../../../ExistedOrder';
import { type CreateAutoCreditProps } from '../../types/form-types';

const Contacts: React.FC = () => {
  const { dicts } = useAppSelector((state) => state.dict);

  const { isFieldsFrozen } = useContext(CreateTabContext);
  const { control } = useFormContext<CreateAutoCreditProps>();

  const addContactsIsRelated = useMemo(
    () =>
      setDictionaryOptions(DictTypes.AddContactsIsRelated, dicts)?.map(
        (item) => ({
          value: String(item.value),
          label: String(item.label)
        })
      ) || [],
    [dicts]
  );

  return (
    <div className="contacts">
      <div className="order-step__subtitle">Контактные лица</div>

      <div className="order-step__grid">
        <Controller
          control={control}
          name="contactName"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: { value: 1, message: 'Пожалуйста, введите данные' }
          }}
          render={({ field, fieldState: { error } }) => (
            <Input
              {...field}
              value={field.value}
              label="ФИО"
              error={error?.message}
              isFrozen={isFieldsFrozen}
              isRequired
            />
          )}
        />
        <Controller
          control={control}
          name="contactPhone"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: {
              value: '+7 (777) 666-55-44'.length,
              message: 'Неверный номер телефона'
            }
          }}
          render={({ field, fieldState: { error } }) => (
            <MaskedInput
              {...field}
              type="tel"
              value={field.value}
              label="Номер телефона"
              error={error?.message}
              mask="+7 (___) ___-__-__"
              replacement={{ _: /\d/ }}
              isFrozen={isFieldsFrozen}
              isRequired
            />
          )}
        />
        <Controller
          control={control}
          name="contactType"
          rules={{
            required: 'Пожалуйста, введите данные',
            minLength: { value: 1, message: 'Пожалуйста, введите данные' }
          }}
          render={({ field, fieldState: { error } }) => (
            <Select
              {...field}
              label="Кем приходится"
              selectedValue={addContactsIsRelated.find(
                (item) => item.value === field.value
              )}
              onChange={(value) => field.onChange(value.value)}
              options={addContactsIsRelated}
              error={error?.message}
              isFrozen={isFieldsFrozen}
              isRequired
            />
          )}
        />
      </div>
    </div>
  );
};

export default Contacts;
